import React, {useEffect, useState} from "react";
import styles from "./unlinkTablesForPromosItemsScreen.module.scss"
import {Droppable} from "react-beautiful-dnd";
import {useTypedSelector} from "../../../../../../hooks/useTypeSelector";
import {PromoDto, PromoItemsDto} from "../../../../../../dtos";
import {UnlinkPromoOrItem} from "./unlinkedPromoOrItem/unlinkedPromoOrItem";
import {
    addItemsForUnlinkedPromotionsItemsMenu,
    changeActiveUnlinkTab, toggleUnlinkPromotionsItemsPanel
} from "../../../../../../store/actionCreators/promotionsItemsCreators";
import {useDispatch} from "react-redux";
import {getFlippingFlyer} from "../../../../../../store";

interface Props {
    onChangeSelectedPromos: (promo: PromoDto, event: React.MouseEvent<HTMLElement>, index: number) => void;
    onChangeSelectedItems: (item: PromoItemsDto, e: React.MouseEvent<HTMLElement>) => void;
    targetItems: PromoItemsDto[];
    targetUnlinkedPromos: PromoDto[];
}


export const UnlinkTablesForPromosItemsScreen = (props: Props) => {
    const promotionsItemsState = useTypedSelector((state) => state.promotionsAndItems);
    let flyerDetailsState = useTypedSelector((state) => state.flyerDetails);
    const [itemsState, setItemsState] = useState<PromoItemsDto[]>([]);
    const dispatch = useDispatch();

    useEffect(() => {
        if (promotionsItemsState.type === 'ATTACH_ITEMS_TO_FLYER_SUCCESS' && !promotionsItemsState.targetFrameId) {
            const itemsWhichShouldBeUnlinkFromTargetPromo = promotionsItemsState.targetPromo.flyerPromoItems.filter((promoItem: PromoItemsDto) => {
                const isIterableItemShouldBeUnlink = promotionsItemsState.itemsIds.find((id: number) => id === promoItem.fpiRecId);
                if (isIterableItemShouldBeUnlink) {
                    return promoItem;
                }
            })
            dispatch(addItemsForUnlinkedPromotionsItemsMenu(itemsWhichShouldBeUnlinkFromTargetPromo));
            dispatch(toggleUnlinkPromotionsItemsPanel(true));
            dispatch(changeActiveUnlinkTab("Items"));
            dispatch(getFlippingFlyer(flyerDetailsState.flyRecId));
        }
    }, [promotionsItemsState.type]);


    useEffect(() => {
        let newItemsArray = promotionsItemsState.unlinkItems.filter((item: PromoItemsDto) => {
            if (promotionsItemsState.searchTerm.searchTermForUnlinkedItems !== "") {
                if (item.fpiKeywords && item.fpiKeywords?.toLowerCase().indexOf(promotionsItemsState.searchTerm.searchTermForUnlinkedItems.toLowerCase()) !== -1) {
                    return item;
                }
            } else {
                return item;
            }
        })

        setItemsState(newItemsArray);
    }, [promotionsItemsState.searchTerm.searchTermForUnlinkedItems, promotionsItemsState.unlinkItems]);

    return (
        <>
            {promotionsItemsState.activeTab === "Promotions" &&
            <Droppable droppableId={`unlink_promotions_area`}>
                {({innerRef, placeholder}) => (
                    <div ref={innerRef}
                         className={styles.tables}
                    >
                        {
                            promotionsItemsState.unlinkPromos && promotionsItemsState.unlinkPromos.length > 0 && promotionsItemsState.unlinkPromos.map((key: PromoDto, index: number) => {
                                const isSelected: boolean = props.targetUnlinkedPromos.some((promo: PromoDto) => promo.flrRecId === key.flrRecId);
                                if (promotionsItemsState.searchTerm.searchTermForUnlinkedPromotions !== "") {
                                    if (key.flrKeywords && key.flrKeywords?.toLowerCase().indexOf(promotionsItemsState.searchTerm.searchTermForUnlinkedPromotions.toLowerCase()) !== -1) {
                                        return <UnlinkPromoOrItem key={key.flrRecId} promo={key}
                                                                  tabName={promotionsItemsState.activeTab}
                                                                  index={index}
                                                                  onChangeSelectedPromos={props.onChangeSelectedPromos}
                                                                  isSelected={isSelected}
                                                                  isHebrew={flyerDetailsState?.flyLacRec?.lacCode! === 'he-IL'}
                                        />
                                    }
                                } else {
                                    return <UnlinkPromoOrItem key={key.flrRecId} promo={key}
                                                              tabName={promotionsItemsState.activeTab}
                                                              index={index}
                                                              onChangeSelectedPromos={props.onChangeSelectedPromos}
                                                              isSelected={isSelected}
                                                              isHebrew={flyerDetailsState?.flyLacRec?.lacCode! === 'he-IL'}
                                    />
                                }
                            })
                        }
                        <span style={{
                            display: "none"
                        }}>
                            {placeholder}
                        </span>
                    </div>

                )}
            </Droppable>
            }
            {promotionsItemsState.activeTab === "Items" &&
            <div className={styles.unlink_items_columns}>
                <Droppable droppableId={`unlink_items_area_1`}>
                    {({innerRef, placeholder, droppableProps}) => (
                        <div
                            ref={innerRef}
                            {...droppableProps}
                            className={styles.unlink_table_item_first}
                        >
                            {itemsState && itemsState.length > 0 && itemsState.map((key: PromoItemsDto, index: number) => {
                                const isSelected: boolean = props.targetItems.some((item: PromoItemsDto) => item.fpiRecId === key.fpiRecId);
                                const draggingRecId: number = promotionsItemsState.draggingItemRecId;
                                const isHide: boolean = isSelected &&
                                    Boolean(draggingRecId) &&
                                    draggingRecId !== key.fpiRecId;
                                if (index % 2 === 0 || index === 0) {
                                    console.log(index);
                                    return <UnlinkPromoOrItem key={`${key.fpiRecId}${index}`}
                                                              item={key}
                                                              tabName={promotionsItemsState.activeTab}
                                                              index={index}
                                                              onChangeSelectedItems={props.onChangeSelectedItems}
                                                              isSelected={isSelected}
                                                              targetItems={props.targetItems}
                                                              isHebrew={flyerDetailsState?.flyLacRec?.lacCode! === 'he-IL'}
                                                              isHide={isHide}
                                    />
                                }
                            })}
                            <span style={{
                                display: "none"
                            }}>
                                {placeholder}
                            </span>
                        </div>

                    )}
                </Droppable>
                <Droppable droppableId={`unlink_items_area_2`}>
                    {({innerRef, placeholder, droppableProps}) => (
                        <div
                            ref={innerRef}
                            {...droppableProps}
                            className={styles.unlink_table_item_second}
                        >
                            {itemsState && itemsState.length > 0 && itemsState.map((key: PromoItemsDto, index: number) => {
                                const isSelected: boolean = props.targetItems.some((item: PromoItemsDto) => item.fpiRecId === key.fpiRecId);
                                const draggingRecId: number = promotionsItemsState.draggingItemRecId;
                                const isHide: boolean = isSelected &&
                                    Boolean(draggingRecId) &&
                                    draggingRecId !== key.fpiRecId;
                                if (index % 2 !== 0 && index !== 0) {
                                    console.log(index);
                                    return <UnlinkPromoOrItem key={key.fpiRecId}
                                                              item={key}
                                                              tabName={promotionsItemsState.activeTab}
                                                              index={index}
                                                              onChangeSelectedItems={props.onChangeSelectedItems}
                                                              isSelected={isSelected}
                                                              targetItems={props.targetItems}
                                                              isHebrew={flyerDetailsState?.flyLacRec?.lacCode! === 'he-IL'}
                                                              isHide={isHide}
                                    />
                                }
                            })}

                            <span style={{
                                display: "none"
                            }}>
                                {placeholder}
                            </span>

                        </div>

                    )}
                </Droppable>
            </div>
            }
        </>
    )
}